type Props = {
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
};

export default function FlameSparkleIcon({
  width = 32,
  height = 32,
  fill = '#FFAA00',
  stroke = 'none'
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 32 32`}
      fill={stroke}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 9L27.6639 11.9241C27.9112 13.0133 28.7431 13.8749 29.8229 14.1603L33 15L29.8229 15.8397C28.7431 16.1251 27.9112 16.9867 27.6639 18.0759L27 21L26.3361 18.0759C26.0888 16.9867 25.2569 16.1251 24.1771 15.8397L21 15L24.1771 14.1603C25.2569 13.8749 26.0888 13.0133 26.3361 11.9241L27 9Z"
        fill={fill}
      />
      <path
        d="M20 0L20.6639 2.92412C20.9112 4.0133 21.7431 4.87493 22.8229 5.16032L26 6L22.8229 6.83968C21.7431 7.12507 20.9112 7.9867 20.6639 9.07588L20 12L19.3361 9.07588C19.0888 7.9867 18.2569 7.12507 17.1771 6.83968L14 6L17.1771 5.16032C18.2569 4.87493 19.0888 4.0133 19.3361 2.92412L20 0Z"
        fill={fill}
      />
      <path
        d="M7.49879 14.1884C9.7886 22.2525 11.0012 18.0401 11.0016 13.3408L11.0019 9.46838C11.002 8.75184 11.9589 8.47942 12.3522 9.08398L19.7604 19.1668C20.5706 20.412 21.0008 21.8573 21.0007 23.3332C21.0004 27.0423 18.316 30.2327 14.594 30.9473L14.0044 31.0605C12.6808 31.3146 11.3193 31.3145 9.99567 31.0602L9.78785 31.0202C5.84424 30.2624 3.00041 26.8814 3.00074 22.9512C3.00085 21.7143 3.28632 20.4933 3.83589 19.3792L6.43044 14.1197C6.65608 13.6623 7.33635 13.706 7.49879 14.1884Z"
        fill={fill}
      />
    </svg>
  );
}
